import {
  Component,
  effect,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  signal,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "app/features/auth/services/auth.service";
import { QrLinkService } from "app/shared/services/qrlink.service";
import { Socket } from "ngx-socket-io";
import { Subscription } from "rxjs";
import { TypeQrLink } from "../../enums/enums/typeQrLink.enum";
import { QrCodeComponent } from "../qr-code/qr-code.component";
import { SharedModule } from "../../shared.module";

@Component({
  selector: "vl-qr-link",
  standalone: true,
  imports: [QrCodeComponent, SharedModule],
  templateUrl: "./qr-link.component.html",
  styleUrls: ["./qr-link.component.scss"],
})
export class QrLinkComponent extends Socket implements OnInit {
  @Output() completed = new EventEmitter();

  completeMessage$ = this.fromEvent("complete");
  connectedMessage$ = this.fromEvent("connected");
  scannedMessage$ = this.fromEvent("scanned");
  subComplete: Subscription;
  subConnected: Subscription;
  subScanned: Subscription;

  socketId = signal<string>(null);
  linkUrl = signal<string>(null);

  constructor(
    public dialogRef: MatDialogRef<QrLinkComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      type: TypeQrLink;
      lotId: string;
      controleId: string;
      ofId: string;
      opeId: string;
      forList: boolean;
    },
    public authService: AuthService,
    private qrLinkService: QrLinkService,
  ) {
    const proto = location.protocol === "https:" ? "wss:" : "ws:";
    const url = `${proto}//${location.host}`;
    super({
      url,
      options: {
        path: "/ws/qrLinkSocket/",
        extraHeaders: {
          authorization: `Bearer ${authService.tokenSignal()}`,
        },
        transports: ["websocket"],
      },
    });
    effect(
      async () => {
        if (this.socketId()) {
          try {
            const res = await this.qrLinkService.getShortLink({
              hostname: location.host,
              socketId: this.socketId(),
              token: this.authService.tokenSignal(),
              type: this.data.type,
              lotId: this.data.lotId,
              controleId: this.data.controleId,
              ofId: this.data.ofId,
              opeId: this.data.opeId,
              forList: this.data.forList,
              ssoToken: this.authService.ssoSignal().token,
            });
            this.linkUrl.set(res);
          } catch (error) {
            this.linkUrl.set(null);
          }
        }
      },
      { allowSignalWrites: true },
    );
    effect(() => {
      if (this.linkUrl() && location.host.includes("localhost")) {
        window.open(this.linkUrl(), "_blank");
      }
    });
  }

  start() {
    this.subComplete?.unsubscribe();
    this.subConnected?.unsubscribe();
    this.subScanned?.unsubscribe();

    this.subConnected = null;
    this.subConnected = this.connectedMessage$.subscribe((resp: any) => {
      try {
        if (resp) {
          this.socketId.set(resp.id);
        }
      } catch (e) {
        console.error("no response on connected");
      }
    });

    this.subScanned = null;
    this.subScanned = this.scannedMessage$.subscribe((resp: any) => {
      try {
        if (resp) {
          this.qrLinkService.setLinked(true);
        }
      } catch (e) {
        console.error("no response on connected");
      }
    });

    this.subComplete = null;
    this.subComplete = this.completeMessage$.subscribe((resp: any) => {
      try {
        if (resp) {
          this.qrLinkService.setLinked(false);
          this.dialogRef.close(resp);
          //this.completed.emit(resp);
        }
      } catch (e) {
        console.error("no response on complete");
      }
    });
  }

  stop() {
    this.disconnect();
    this.subComplete?.unsubscribe();
    this.subConnected?.unsubscribe();
    this.subScanned?.unsubscribe();
  }

  ngOnInit(): void {
    this.start();
  }

  ngOnDestroy() {
    this.stop();
  }
}
